import ICON_CASH from '../../../public/static/v4/gift/icon-event-cash.svg';
import {
  getColor,
  getContentProps,
  getImageUrl,
  I_ContentMeta,
} from '../../common/state/apiGet';
import {getTimeStamp} from '../../common/util/date';
import {convertHexToRgb, toCamelCase} from '../../common/util/string';
import {IRewardType} from '../../commonSub/type';
import {IEvent, IGiftRedDotStatus, ITicket} from '../type';

export function getGiftRedDotStatus(
  data: I_GiftRedDotStatus
): IGiftRedDotStatus {
  return {
    hasEventRedDot: data.eventsRedDot,
    hasTicketRedDot: data.giftsRedDot,
  };
}

interface I_GiftRedDotStatus {
  eventsRedDot: boolean;
  giftsRedDot: boolean;
}

export function getGiftEvents({
  events,
  eventsLastReadDateTime,
}: I_Gift): IEvent {
  const now = Date.now();

  return {
    items: events.map(event => {
      const rewardType = (toCamelCase(event.reward?.type) ||
        'cash') as IRewardType;
      const rewardIcon = event.reward.iconImage;
      return {
        eventThumbImg: getImageUrl(event.thumbnailImage, {hasAlpha: true}),
        eventTitleImg: getImageUrl(event.titleImage, {hasAlpha: true}),
        bgColor: getColor(event.backgroundColor),
        bgColorRgb: convertHexToRgb(`#${event.backgroundColor}`),
        rewardType,
        rewardQuantity: event.reward?.cashAmount || 0,
        rewardIcon:
          rewardType === 'cash'
            ? ICON_CASH
            : rewardIcon
              ? getImageUrl(rewardIcon, {hasAlpha: true})
              : undefined,
        rewardTitle: event.reward?.rewardItemName,
        questCampaignId: event.questCampaignId,
        eventId: event.eventId,
        isComplete: event.completed,
        isExpired: now > getTimeStamp(event.availableToDateTime),
      };
    }),
    eventTabLastReadDateTime: eventsLastReadDateTime,
  };
}

export function getGiftTickets({
  gifts: tickets,
  giftsLastReadDateTime,
}: I_Gift): ITicket {
  return {
    items: tickets.map(ticket => ({
      id: ticket.id,
      content: {
        ...getContentProps(ticket.ticket.content, [
          'id',
          'sid',
          'title',
          'thumbImg',
          'titleImg',
          'badges',
        ]),
        bgColorRgb: ticket.received ? 'var(--grey-08)' : 'var(--dark-purple)',
      },
      ticketCount: ticket.ticket?.quantity || 0,
      isComplete: ticket.received,
    })),
    ticketTabLastReadDateTime: giftsLastReadDateTime,
  };
}

export function getReceivedTicket({ticket, expiresDateTime}: I_ReceivedTicket) {
  const now = Date.now();
  return {
    content: getContentProps(ticket.content, ['id', 'sid', 'title']),
    ticketCount: ticket.quantity || 0,
    isExpired: now > getTimeStamp(expiresDateTime),
  };
}

interface I_Gift {
  events: Array<{
    id: number;
    thumbnailImage: string;
    titleImage: string;
    backgroundColor: string;
    reward: {
      iconImage?: string;
      cashAmount?: number;
      type: string;
      rewardItemName?: string;
    };
    availableToDateTime: string;
    completed: boolean;
    questCampaignId: number;
    eventId: number;
  }>;
  gifts: Array<{
    id: number;
    received: boolean;
    ticket: {
      quantity: number;
      content: I_ContentMeta;
    };
  }>;
  eventsLastReadDateTime: string;
  giftsLastReadDateTime: string;
}

interface I_ReceivedTicket {
  ticket: {
    content: I_ContentMeta;
    quantity: number;
  };
  expiresDateTime: string;
}
